// src/data/drives.js
export const drives = [
  {
    company: "Infosys",
    date: "2025-10-15",
    eligibility: "CGPA ≥ 7.0 | CSE, ECE",
    url: "https://www.infosys.com/careers/"
  },
  {
    company: "Deloitte",
    date: "2025-10-20",
    eligibility: "CGPA ≥ 7.0 | CSE, ECE, IT",
    url: "https://www2.deloitte.com/global/en/careers"
  },
  {
    company: "TCS",
    date: "2025-10-25",
    eligibility: "CGPA ≥ 6.5 | All Branches",
    url: "https://www.tcs.com/careers"
  }
];
